module.exports = __webpack_public_path__ + "static/media/pn.78a02785.svg";